import React, { useEffect, useState } from 'react';
import { getStartHeaderInfos } from 'services/api/microfwk';
import { getHKS, removeHKS, setHKS } from 'utils/HKS';
import { trackError } from 'utils/trackError';
import _ from 'lodash';
import { apiCall, updateSwaggerManager } from 'api';
import { useMountedInitialScripts } from 'hooks/useMountScripts/useMountedInitialScripts';
import { getTranslation } from 'utils/getTranslation';
import { removeModal, showModal } from 'actions/response';
import { useSetState } from 'ahooks';
import { useDispatch, useSelector } from 'react-redux';
import ModalFactory from 'components/modal/ModalFactory';
import ContentLoader from 'containers/Player/components/ContentLoader';

const SHI_NOT_SUPORTED_REGION_ERROR = 'Region no soportada';
const SHI_NOT_SUPORTED_REGION_ERROR_CODE = 'error_params_region';

const StartHeaderInfoProvider = ({ children }) => {
  useMountedInitialScripts();
  const [isSHIReady, setIsSHIReady] = useState(false);
  const [hasSHIError, setHasSHIError] = useSetState(false);
  const dispatch = useDispatch();
  const modalConf = useSelector(state => state.modal);

  const handleSHIError = (errorMsg = '') => {
    const ERROR_MODAL_CONFIG = {
      modalType: 'ErrorSimple',
      props: {
        message: '',
        onAccept: () => {
          dispatch(removeModal('ErrorSimple'));
          location.reload();
        },
        acceptText: 'Reintentar',
        withClose: false,
      },
    };

    ERROR_MODAL_CONFIG.props.message = errorMsg;
    dispatch(showModal(ERROR_MODAL_CONFIG));
    setHasSHIError(true);
    setIsSHIReady(true);
  };

  useEffect(() => {
    sessionStorage.removeItem('sendedStartupMetrics');
    let phpSID = getHKS();
    if (!phpSID) {
      phpSID = '';
      removeHKS();
    }
    if (phpSID === 'undefined') {
      phpSID = '';
      removeHKS();
      const info = {
        date: new Date(),
        userdata: localStorage.getItem('loginInfo.logged_user_data'),
        region: localStorage.getItem('loginInfo.region'),
        userhash: localStorage.getItem('loginInfo.userhash'),
      };
      trackError(info);
    }
    getStartHeaderInfos(phpSID)
      .then(shiRes => {
        //MANEJO DE ERROR DEL SHI
        if (
          shiRes?.errors?.code === SHI_NOT_SUPORTED_REGION_ERROR_CODE ||
          shiRes?.errors?.error[0] === SHI_NOT_SUPORTED_REGION_ERROR
        ) {
          handleSHIError(shiRes?.response?.Error || shiRes?.errors?.error[0]);
          return;
        }
        //SHI exitosa
        localStorage.setItem('startHeaderInfoResponse', JSON.stringify(shiRes));
        const HKS = _.get(shiRes, ['response', 'session_stringvalue']);
        const region = _.get(shiRes, ['response', 'region']);
        setHKS(HKS);
        updateSwaggerManager(apiCall, { HKS, region }).then(() => {
          setIsSHIReady(true);
        });
      })
      .catch(e => {
        const error = e?.response?.data?.errors?.error;
        if (
          error?.[0] === SHI_NOT_SUPORTED_REGION_ERROR ||
          error?.[0] === SHI_NOT_SUPORTED_REGION_ERROR_CODE
        ) {
          handleSHIError(e?.response?.data?.response?.Error || error?.[0]);
          return;
        }
        const shi = localStorage.getItem('startHeaderInfoResponse');
        if (shi) return setIsSHIReady(true);
        location.reload();
      });
  }, []);

  if (!isSHIReady) return <ContentLoader />;
  return <>{hasSHIError ? ModalFactory.create(modalConf) : children}</>;
};

export default StartHeaderInfoProvider;
